// @ts-nocheck
import React from 'react'
import './index.css'
import { ThemeProvider } from 'contexts/ThemeContext'
import { Toaster } from 'react-hot-toast'
import { Provider } from 'react-redux'
import { store } from 'redux/store'
import './lib/i18n'
import './lib/cognito'
import { AuthContextTsp, AuthProviderTsp } from 'lib/auth/AuthContext'
import { APP_MODES } from 'lib/mode/mode'
import { RouterProvider, Routes, Route } from 'react-router-dom'
import { createAppRouter, routerConfig } from 'router'
import { AppModeProvider, useAppMode } from 'lib/mode/AppModeContext'

// UMD/Unity may mount without index.html; mirror SPA font links from vite-plugin-fonts era.
if (typeof document !== 'undefined') {
  const already =
    document.querySelector('link[href*="Source+Sans+Pro"]') ||
    document.querySelector('link[href*="Source%2BSans%2BPro"]')
  if (!already) {
    const preGoogle = document.createElement('link')
    preGoogle.rel = 'preconnect'
    preGoogle.href = 'https://fonts.googleapis.com'
    document.head.appendChild(preGoogle)
    const preGstatic = document.createElement('link')
    preGstatic.rel = 'preconnect'
    preGstatic.href = 'https://fonts.gstatic.com'
    preGstatic.crossOrigin = 'anonymous'
    document.head.appendChild(preGstatic)
    const font = document.createElement('link')
    font.rel = 'stylesheet'
    font.href =
      'https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;600;700&display=swap'
    document.head.appendChild(font)
  }
}

function TspRoutes() {
  const renderRoutes = (routes: typeof routerConfig): React.ReactNode => {
    return routes.map((route, index) => {
      let element = route.element

      if (route.Component) {
        const Comp = route.Component
        element = <Comp />
      }

      if (route.lazy && !element) {
        const LazyRouteComponent = React.lazy(async () => {
          const routeModule = await route.lazy()
          if (routeModule.Component) {
            return { default: routeModule.Component }
          }
          if (routeModule.element) {
            return { default: () => routeModule.element }
          }
          return { default: () => <div>Route not found</div> }
        })

        element = (
          <React.Suspense fallback={<div>Loading...</div>}>
            <LazyRouteComponent />
          </React.Suspense>
        )
      }

      let relativePath = route.path
      if (relativePath && relativePath.startsWith('/')) {
        relativePath = relativePath.substring(1)
      }

      return (
        <Route
          key={relativePath || index}
          path={relativePath || undefined}
          index={route.index}
          element={element}
        >
          {route.children && renderRoutes(route.children)}
        </Route>
      )
    })
  }

  return <Routes>{renderRoutes(routerConfig)}</Routes>
}

export function AppWrapper() {
  const { mode } = useAppMode()
  const isUnityMode = mode === 'unity'

  return (
    <AppModeProvider initialMode='unity'>
      <Provider store={store}>
        <ThemeProvider>
          {isUnityMode ? (
            <TspRoutes />
          ) : (
            <RouterProvider router={createAppRouter(false)} />
          )}
        </ThemeProvider>
        <Toaster />
      </Provider>
    </AppModeProvider>
  )
}

export { APP_MODES, AuthProviderTsp, AuthContextTsp, AppModeProvider }
